import React from "react";
// import MaskedInput from "react-maskedinput";
import MaskedInput from "react-text-mask";

export default function PhoneInput(props) {
const [value, setValue] = React.useState('');
  const handleChange = React.useCallback((e) => {
    props.onChange(e);
  }, []);

  React.useEffect(() => {
    setValue(props.value);
  }, [props.value]);
  return (
    <MaskedInput
      // mask="+38(011)111-11-11"
      mask={['+', '3', '8', '0', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
      placeholder="+380"
      guide={false}
      // onChange={handleChange}
      // value={value}
      {...props}
    />
  );
}
